var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserLinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  d: "M42.4062 44.8641C42.1628 42.5357 40.7023 40.2569 38.0978 38.4734C31.4769 33.9653 20.5718 33.9653 13.9022 38.4734C11.2977 40.2569 9.83717 42.5357 9.59375 44.8641M33.1581 16.7747C33.6937 17.8646 34.0101 19.1031 34.0101 20.4159C33.9858 24.8002 30.6023 28.3918 26.3182 28.5157C26.1478 28.4909 25.9287 28.4909 25.734 28.5157C21.4498 28.3671 18.042 24.8002 18.042 20.4159C18.042 15.9325 21.5959 12.2913 26.0261 12.2913M12.9845 4.65109C16.7757 2.33479 21.232 1 26 1C39.8071 1 51 12.1929 51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 22.0776 1.9033 18.3662 3.51323 15.0625"
})));
export default SvgUserLinline;